<template>
  <div class="app-builds">
    <div class="app-build-list panel list-panel">
      <el-container>
        <el-header class="clearfix">
          <h2 class="card-title">App Builds</h2>
          <el-radio-group v-model="groupBy" size="mini" style="margin-left: 20px;">
            <el-radio-button label="Created At"></el-radio-button>
            <el-radio-button label="Client Name"></el-radio-button>
            <el-radio-button label="A-Z"></el-radio-button>
          </el-radio-group>
          <el-button class="header-btn pull-right"
                     type="primary"
                     icon="el-icon-circle-plus"
                     @click="createAppBuild"> Create New App Build</el-button>
          <div class="search-bar pull-right">
            <el-input placeholder="Search..." v-model="searchTerm" />
          </div>
        </el-header>
        <el-main>
          <el-card class="box-card"
                   :key="key"
                   v-for="(appBuilds, key) in appBuildsFiltered">
            <div slot="header" class="clearfix">
              <span><b>{{ key }}</b></span>
            </div>
            <div class="list-group">
              <el-button plain
                         class="app-build-list-item list-item"
                         @click="editSelectedAppBuild(appBuild)"
                         :key="appBuild.id"
                         v-for="appBuild in appBuilds">
                <div class="list-item-btn">
                  <img :src="appBuild.icon_57_url" class="client-code"/>
                  <div class="info">
                    <div class="title"><b>{{ appBuild.name }} v{{ appBuild.version_num }}</b></div>
                    <div class="code">{{ appBuild.project_code }} - {{ appBuild.client_name }}</div>
                    <div class="created-at">Created on {{ appBuild.created_at | localiseUTCDate }} by {{ appBuild.user_full_name }}</div>
                    <div class="bundle-id">{{ appBuild.ios_bundle_id }}</div>
                  </div>

                  <a :href="appBuild.mlaunch_url" target="_blank" class="mlaunch-link" @click.stop>
                    <el-button type="small"><b>{{ appBuild.uuid}}</b> <icon name="external-link-square-alt" /></el-button>
                  </a>

                  <div class="stats tags">
                    <el-tag size="small" :type="appBuild.page_views < 2 ? 'warning' : ''"><icon name="laptop" />{{ appBuild.page_views }} Views</el-tag>
                    <el-tag size="small" :type="appBuild.ios_downloads == 0 ? 'danger' : 'success'"
                            v-if="appBuild.ios_ipa_path !== null"><icon name="brands/apple" /> {{ appBuild.ios_downloads }} Installs</el-tag>
                    <el-tag size="small" :type="appBuild.android_downloads == 0 ? 'danger' : 'success'"
                            v-if="appBuild.android_apk_path !== null"><icon name="brands/android" /> {{ appBuild.android_downloads }} Installs</el-tag>
                  </div>

                </div>
              </el-button>
            </div>
          </el-card>
          <el-card class="box-card" v-if="!Object.keys(appBuildsFiltered).length">
            <div slot="header" class="clearfix">
              <span><b>No App Builds Found!</b></span>
            </div>
          </el-card>
        </el-main>
      </el-container>
    </div>
    <app-build-crud v-if="showAppBuildCrud"
                    :appBuild="editAppBuild"
                    @close="appBuildCrudClose" />
  </div>
</template>

<script>
  import moment from 'moment'
  import { mixin as Utils } from '../../mixins/Utils'
  export default {
    name: 'app-builds',
    mixins: [Utils],
    data () {
      return {
        showAppBuildCrud: false,
        searchTerm: '',
        groupBy: 'Created At',
        editAppBuild: null
      }
    },
    methods: {
      editSelectedAppBuild (appBuild) {
        this.editAppBuild = appBuild
        this.showAppBuildCrud = true
      },
      appBuildCrudClose (appBuild) {
        // Handle the Project Crud Dialog closing
        this.showAppBuildCrud = false
        this.editAppBuild = null

        if (appBuild) {
          // this.$router.push({name: 'app-build', params: { app_build_id: appBuild.id }})
        }
      },
      createAppBuild () {
        this.showAppBuildCrud = true
        // this.$router.push({name: 'app-build', params: { app_build_id: 'new' }})
      }
    },
    computed: {
      currentUser () {
        return this.$store.state.users.currentUser
      },
      appBuilds () {
        // Convert the Store object to an array for the LogList component
        return Object.keys(this.$store.state.appBuilds.objects)
        .map((k) => this.$store.state.appBuilds.objects[k])
        .sort((a, b) => {
          return (Date.parse(a.created_at) < Date.parse(b.created_at)) ? 1 : -1
        })
      },
      appBuildsFiltered () {
        let appBuilds = this.appBuilds.filter((appBuild) => {
          if (this.searchTerm !== '') {
            if (appBuild.name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
              appBuild.project_code.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
              appBuild.project_name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
              appBuild.client_name.toLowerCase().includes(this.searchTerm.toLowerCase())) {
              return true
            } else {
              return false
            }
          } else {
            return true
          }
        })

        // Now group the results into 'sort by' categories..
        let optionsObj = {}

        let groupBy = this.$store.state.filters.appBuildsGroupBy // Store will be updated via vuex in watcher

        // Group Projects by the select sort type
        Object.keys(appBuilds)
          .map((k) => this.appBuilds[k])
          .sort((a, b) => {
            if (groupBy === 'A-Z') {
              return a.name > b.name ? 1 : -1
            } else if (groupBy === 'Client Name') {
              return a.client_name > b.client_name ? 1 : -1
            } else {
              // Default - Created At
              return a.created_at > b.created_at ? -1 : 1
            }
          })
          .map((item) => {
            let groupLabel = null
            if (groupBy === 'A-Z') {
              groupLabel = item.name.substring(0, 1).toUpperCase()
            } else if (groupBy === 'Client Name') {
              groupLabel = item.client_name
            } else {
              // Default - Created At
              groupLabel = moment(item.created_at).format('MMM YYYY')
            }

            // Dimension the array if it does not yet exist
            if (!optionsObj.hasOwnProperty(groupLabel)) {
              optionsObj[groupLabel] = []
            }
            optionsObj[groupLabel].push(item)
          })

        // Finally, sort the sub groups by name/date
        for (let groupLabel in optionsObj) {
          optionsObj[groupLabel] = optionsObj[groupLabel].sort((a, b) => {
            if (groupBy === 'A-Z') {
              return a.name > b.name ? 1 : -1
            } else {
              return a.created_at > b.created_at ? -1 : 1
            }
          })
        }

        return optionsObj
      }
    },
    watch: {
      groupBy () {
        this.$store.dispatch('setAppBuildsGroupBy', this.groupBy)
      }
    },
    mounted () {
      this.$store.dispatch('setPageTitle', 'App Builds')
      setTimeout(() => {
        this.$store.dispatch('getAppBuilds')
      }, 500)

      this.groupBy = this.$store.state.filters.appBuildsGroupBy
    }
  }
</script>

<style lang="less" rel="stylesheet/less" scoped>
  .bundle-id {
    font-style: italic;
    font-size: 0.8em;
  }
  .tags {
    margin-left: 25px;
    .el-tag {
      display: block;
      margin-bottom: 3px;
    }

    .fa-icon {
      height: 1em;
      width: auto;
      margin-right: 4px;
      margin-bottom: 1px;
      vertical-align: middle;
    }
  }
  .uuid {
    margin-right: 10px;
  }
  .mlaunch-link {
    .fa-icon {
      height: 1em;
      width: auto;
      margin-left: 4px;
      margin-bottom: 1px;
      vertical-align: middle;
    }

  }
</style>
